var CurrencyEnum = /* @__PURE__ */ ((CurrencyEnum2) => {
  CurrencyEnum2["USD"] = "USD";
  CurrencyEnum2["RUB"] = "RUB";
  CurrencyEnum2["UZS"] = "UZS";
  CurrencyEnum2["EUR"] = "EUR";
  CurrencyEnum2["BYN"] = "BYN";
  CurrencyEnum2["KZT"] = "KZT";
  CurrencyEnum2["IDR"] = "IDR";
  return CurrencyEnum2;
})(CurrencyEnum || {});
const CURRENCY_MAP = {
  [
    "RUB"
    /* RUB */
  ]: "₽",
  [
    "USD"
    /* USD */
  ]: "$",
  [
    "UZS"
    /* UZS */
  ]: "so’m",
  [
    "EUR"
    /* EUR */
  ]: "€",
  [
    "BYN"
    /* BYN */
  ]: "Br",
  [
    "KZT"
    /* KZT */
  ]: "₸",
  [
    "IDR"
    /* IDR */
  ]: "Rp"
};
export {
  CURRENCY_MAP,
  CurrencyEnum
};
